import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarRef,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  ConfirmBoxComponent,
} from './confirm-box/confirm-box.component';
import {
  SnackbarComponent,
  SnackbarTheme,
  SnackbarVerticalPosition,
} from './snackbar/snackbar.component';
import { CaceisIcons } from '../icons/caceis-icon/caceis-icon.component';
import { PromptBoxComponent } from './prompt-box/prompt-box.component';
import { ConfirmBoxModel } from './confirm-box/confirm-box.model';
import { SnackbarModel } from './snackbar/snackbar.model';
import { PromptBoxModel } from './prompt-box/prompt-box.model';

@Injectable({
  providedIn: 'root',
})
export class DialogBoxService {

  static snackbarRef: MatSnackBarRef<any>;
  public snackbarUtil: SnackbarUtil;

  constructor(private dialog: MatDialog, private snackBar: MatSnackBar) {
    this.snackbarUtil = new SnackbarUtil(this);
  }

  confirmBox(data: ConfirmBoxModel): MatDialogRef<ConfirmBoxComponent> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '191px';
    dialogConfig.width = '70vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.id = 'confirm-box-create-user';

    dialogConfig.data = data;

    return this.dialog.open(ConfirmBoxComponent, dialogConfig);
  }

  snackbar(snackbarModel: SnackbarModel): MatSnackBarRef<any> {
    return DialogBoxService.snackbarRef = this.snackBar.openFromComponent(SnackbarComponent, {
      duration: snackbarModel.duration,
      verticalPosition: snackbarModel.verticalPosition as MatSnackBarVerticalPosition,
      horizontalPosition: snackbarModel.horizontalPosition,
      panelClass: [snackbarModel.snackbarTheme],
      data: snackbarModel
    });
  }

  dismissSnackbar(): void {
    if (DialogBoxService.snackbarRef != null) DialogBoxService.snackbarRef.dismiss();
  }

  promptBox(data: PromptBoxModel): MatDialogRef<PromptBoxComponent> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '280px';
    dialogConfig.width = '70vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.id = 'prompt-box-id';
    dialogConfig.data = data;

    return this.dialog.open(PromptBoxComponent, dialogConfig);
  }
}

class SnackbarUtil {
  private snackbarModel: SnackbarModel;

  constructor(private service: DialogBoxService) {
    const _minutes = 5;

    this.snackbarModel = new SnackbarModel();
    this.snackbarModel.duration = _minutes * 60 * 1000;
    this.snackbarModel.verticalPosition = SnackbarVerticalPosition.top;
  }

  showError(label: string): MatSnackBarRef<any> {
    this.snackbarModel.label = label;
    this.snackbarModel.reverse = false;
    this.snackbarModel.snackbarTheme = SnackbarTheme.error;
    return this.service.snackbar(this.snackbarModel);
  }
  showLoad(label: string): MatSnackBarRef<any> {
    this.snackbarModel.label = label;
    this.snackbarModel.reverse = false;
    this.snackbarModel.snackbarTheme = SnackbarTheme.load;
    return this.service.snackbar(this.snackbarModel);
  }
  showWarn(label: string): MatSnackBarRef<any> {
    this.snackbarModel.label = label;
    this.snackbarModel.snackbarTheme = SnackbarTheme.warn;
    this.snackbarModel.icon = CaceisIcons.warning;
    this.snackbarModel.reverse = true;
    return this.service.snackbar(this.snackbarModel);
  }

  showSuccess(label: string): MatSnackBarRef<any> {
    this.snackbarModel.label = label;
    this.snackbarModel.snackbarTheme = SnackbarTheme.success;
    this.snackbarModel.icon = CaceisIcons.checkmark;
    this.snackbarModel.reverse = true;
    return this.service.snackbar(this.snackbarModel);
  }

  showInfo(label: string): MatSnackBarRef<any> {
    this.snackbarModel.label = label;
    this.snackbarModel.snackbarTheme = SnackbarTheme.info;
    this.snackbarModel.icon = CaceisIcons.checkmark;
    this.snackbarModel.reverse = true;
    return this.service.snackbar(this.snackbarModel);
  }
}

/** Exemplo de utilizacao do serviço com dialogo de confirmacao */

/// import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
///
/// constructor(private dialogBoxService : DialogBoxService)
///
/// this.dialogBoxService.confirmBox(
///   {
///     lblTitle: "titulo",
///     lblSubtitle: "subtitulo",
///     color: ConfirmBoxColor.warn,
///     lblCancelButton: 'Cancelar',
///     lblConfirmButton: 'Confirmar',
///     onCancel: ()=> {console.log('cancelado')},
///     onConfirm: ()=> {console.log('confirmado')}
///   }
/// ).afterClosed().subscribe(result => {
///   console.log(result);
/// });

/// Exemplo de utilizacao de snackbar (de erro)
/// this.dialogBoxService.snackbarUtil.showError("Mensagem de erro").afterDismissed().subscribe(() => {
///   console.log('Fechou mensagem de erro');
/// });
